import React from "react"
import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"

const SocialHandles = ({ content }) => {
  const allHandles = content?.socialHandles?.map((item, index) => {
    return (
      <HandleDiv key={item?.handle}>
        {item?.socialIcon?.sourceUrl && (
          <HandleImg
            src={item?.socialIcon?.sourceUrl}
            alt={item?.socialIcon.altText}
          />
        )}
        {item?.linkText && item?.linkUrl && (
          <HandleName href={item?.linkUrl}>{item?.linkText}</HandleName>
        )}
      </HandleDiv>
    )
  })

  return (
    <Wrapper>
      <AllHandles>{allHandles}</AllHandles>
    </Wrapper>
  )
}

export default SocialHandles
const HandleName = styled.a`
  ${text.bodyMdBold};
  color: ${colors.primaryOrange};
  &:hover {
    color: ${colors.primaryPurple};
  }
  transition: color 0.3s ease-in-out;
`
const HandleImg = styled.img`
  width: 2.222vw;
  height: 2.222vw;
  ${media.fullWidth} {
    width: 32px;
    height: 32px;
  }

  ${media.tablet} {
    width: 3.125vw;
    height: 3.125vw;
  }

  ${media.mobile} {
    width: 7.477vw;
    height: 7.477vw;
  }
`
const HandleDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  gap: 0.347vw;
  ${media.fullWidth} {
    gap: 5px;
  }

  ${media.tablet} {
    gap: 0.488vw;
  }

  ${media.mobile} {
    gap: 1.168vw;
    &:last-child {
      display: none;
    }
  }
`
const AllHandles = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 2.778vw;
  ${media.fullWidth} {
    gap: 40px;
  }

  ${media.tablet} {
    gap: 3.906vw;
  }

  ${media.mobile} {
    gap: 9.346vw;
  }
`
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.778vw;
  ${media.fullWidth} {
    gap: 40px;
  }

  ${media.tablet} {
  }

  ${media.mobile} {
  }
`
